// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═════════════════════════════════════════════════════════════════════════
   Attestations BNCB - Déclaration d'accident & Non garantie
   Calque des documents officiels.
   ═════════════════════════════════════════════════════════════════════════ */

.att-page {
  background: #f4f4f4;
  min-height: 100vh;
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.att-toolbar {
  width: 100%;
  max-width: 800px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  padding: 10px 14px;
  background: white;
  border: 1px solid #e7e9ee;
  border-radius: 8px;
}

.att-sheet {
  width: 210mm;
  height: 297mm;
  background: white;
  padding: 16mm 18mm;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  font-family: 'Inter', Arial, sans-serif;
  color: #0b0f14;
  font-size: 11pt;
  line-height: 1.5;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

/* ── Entête Carte Brune (logo + bureaux bilingues) ── */
.att-header {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
}
.att-header-left,
.att-header-right {
  font-family: 'Inter', Arial, sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  color: #0b0f14;
  letter-spacing: 0.3px;
  line-height: 1.3;
}
/* Le francais est la langue de delivrance de l'attestation, l'anglais la
   reprend pour les bureaux voisins : la hierarchie des tailles le dit, comme
   elle le dit deja dans les libelles du tableau (9 pt contre 8 pt). La grille
   de l'en-tete est en 1fr auto 1fr, donc deux tailles differentes laissent le
   logo centre et les deux blocs alignes dos a dos. */
.att-header-left {
  font-size: 11pt;
}
.att-header-right {
  font-size: 8.5pt;
  text-align: right;
}
.att-logo {
  width: 62px; height: 62px;
  border-radius: 50%;
  border: 2px solid #b45309;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Playfair Display', Georgia, serif;
  font-weight: 700;
  font-size: 7pt;
  color: #b45309;
  text-align: center;
  line-height: 1.1;
}
.att-logo-img {
  width: 72px;
  height: 72px;
  object-fit: contain;
  display: block;
  print-color-adjust: exact;
}

/* ── Titre principal ── */
.att-title-block {
  text-align: center;
  margin: 20px 0 18px;
  border: 1.5px solid #0b0f14;
  padding: 14px 24px;
  display: inline-block;
}
.att-title-wrap {
  text-align: center;
  margin-bottom: 18px;
}
.att-title {
  font-family: 'Inter', Arial, sans-serif;
  font-size: 16pt;
  font-weight: 800;
  letter-spacing: 1.2px;
  margin: 0;
  text-transform: uppercase;
}
.att-subtitle {
  font-size: 13pt;
  font-weight: 700;
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.att-sin-line {
  margin-top: 8px;
  font-size: 12pt;
  font-weight: 600;
}
.att-sin-line .sin-label {
  font-weight: 700;
}
.att-sin-line .sin-value {
  display: inline-block;
  min-width: 260px;
  border-bottom: 1px solid #0b0f14;
  padding: 0 10px;
  text-align: center;
  font-family: 'JetBrains Mono', Menlo, monospace;
  font-size: 11pt;
}

/* ── Encadré IMPORTANT ── */
.att-important {
  border: 0.5px solid #5a6676;
  padding: 8px 14px;
  margin: 14px 0 18px;
  font-size: 9.5pt;
  line-height: 1.45;
  color: #2a3340;
}
.att-important strong {
  font-weight: 700;
  color: #0b0f14;
}
.att-important .center {
  text-align: center;
  margin-top: 4px;
}

/* ── Paragraphe d'accroche ── */
.att-accroche {
  margin: 10px 0 16px;
  font-size: 11pt;
  line-height: 1.55;
  text-align: justify;
}

/* ── Tableau d'informations (bordures fines) ── */
.att-info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
  font-size: 10pt;
}
.att-info-table td {
  border: 0.5px solid #0b0f14;
  padding: 6px 10px;
  vertical-align: middle;
}
.att-info-table .att-label {
  width: 52%;
  font-size: 9pt;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #0b0f14;
  font-weight: 600;
}
.att-info-table .att-label em {
  font-style: italic;
  color: #8a95a5;
  font-weight: 400;
  font-size: 8pt;
  margin-left: 4px;
  text-transform: none;
  letter-spacing: 0;
}
.att-info-table .att-value {
  font-size: 10.5pt;
  font-weight: 600;
  color: #0b0f14;
}
.att-info-table .att-value.mono {
  font-family: 'JetBrains Mono', Menlo, monospace;
  letter-spacing: 0.4px;
}
.att-info-table .att-value-with-code {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.att-info-table .att-initiales {
  font-family: 'JetBrains Mono', Menlo, monospace;
  font-weight: 700;
  letter-spacing: 2px;
  padding-left: 16px;
  border-left: 1px solid #0b0f14;
  margin-left: 12px;
}

/* ── Texte narratif (pour attestation de non garantie) ── */
.att-narratif {
  font-size: 11pt;
  line-height: 1.7;
  margin: 18px 0;
  text-align: justify;
}
.att-narratif strong.underline {
  font-weight: 700;
  text-decoration: underline;
  font-style: italic;
}
.att-narratif .pj-label {
  font-weight: 700;
  text-decoration: underline;
  font-size: 11pt;
}

/* ── Fermeture (NB, signatures) ── */
.att-closing {
  margin-top: 14px;
  font-size: 10pt;
  line-height: 1.55;
}
.att-nb {
  font-style: italic;
  color: #2a3340;
  font-size: 9.5pt;
  line-height: 1.45;
  margin: 12px 0;
}
.att-nb strong {
  color: #0b0f14;
  text-decoration: underline;
  font-style: normal;
}
.att-fait-a {
  margin-top: 14px;
  text-align: right;
  font-size: 11pt;
}
.att-pour-bncb {
  text-align: right;
  font-size: 11pt;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 2px;
  letter-spacing: 0.4px;
}
.att-signature-espace {
  min-height: 16mm;
}

/* ── Footer (adresse) ── */
.att-footer {
  position: absolute;
  bottom: 10mm;
  left: 18mm;
  right: 18mm;
  text-align: center;
  font-size: 8.5pt;
  color: #2a3340;
  line-height: 1.4;
  border-top: 0.5px solid #0b0f14;
  padding-top: 4px;
}

/* ══════════ Print rules ══════════ */
@page {
  size: A4 portrait;
  margin: 0;
}

@media print {
  body, html {
    background: white !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .att-page {
    background: white;
    padding: 0;
  }
  .att-toolbar {
    display: none !important;
  }
  .att-sheet {
    box-shadow: none;
    width: 210mm;
    height: 297mm;
    margin: 0;
    padding: 16mm 18mm;
    page-break-after: avoid;
    page-break-inside: avoid;
  }
  .no-print {
    display: none !important;
  }
}

/* ═══════════════════════════════════════════════════════════════
   CONFIRMATION DE GARANTIE (dossier TE, adressée au bureau homologue)
   Reprend l'en-tête, le tableau et le pied de page de l'attestation ;
   n'ajoute que la mise en page propre à une lettre.
   ═══════════════════════════════════════════════════════════════ */
.cg-destinataire {
  margin-top: 14mm;
  text-align: center;
  font-size: 10.5pt;
  letter-spacing: 0.5px;
  line-height: 2;
}

.cg-lieu-date {
  font-size: 10pt;
}

.cg-corps {
  font-size: 11pt;
  line-height: 1.75;
  text-align: justify;
  margin: 6mm 0;
}

/* Le tableau de références ne prend pas toute la largeur : c'est un encadré de
   renvoi au milieu d'une lettre, pas le corps du document. */
.cg-table {
  width: 88%;
  margin: 0 auto 6mm;
}

.cg-table .cg-label {
  width: 34%;
  font-weight: 600;
}

.cg-salutation {
  font-size: 11pt;
  margin-top: 4mm;
  letter-spacing: 0.3px;
}

/* Champ absent du dossier : la ligne s'imprime en pointillés, à compléter à la
   main, plutôt que de laisser un blanc qui passerait inaperçu. */
.cg-a-completer {
  letter-spacing: 2px;
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/pages/sinistres/attestations.css"],"names":[],"mappings":"AAAA;;;8EAG8E;;AAE9E;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;;EAEE,uCAAuC;EACvC,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;;;qDAIqD;AACrD;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EAEd,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,4DAA4D;AAC5D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,4BAA4B;IAC5B,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;;;oEAIoE;AACpE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;6DAC6D;AAC7D;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;iEACiE;AACjE;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["/* ═════════════════════════════════════════════════════════════════════════\n   Attestations BNCB - Déclaration d'accident & Non garantie\n   Calque des documents officiels.\n   ═════════════════════════════════════════════════════════════════════════ */\n\n.att-page {\n  background: #f4f4f4;\n  min-height: 100vh;\n  padding: 20px 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.att-toolbar {\n  width: 100%;\n  max-width: 800px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n  padding: 10px 14px;\n  background: white;\n  border: 1px solid #e7e9ee;\n  border-radius: 8px;\n}\n\n.att-sheet {\n  width: 210mm;\n  height: 297mm;\n  background: white;\n  padding: 16mm 18mm;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  font-family: 'Inter', Arial, sans-serif;\n  color: #0b0f14;\n  font-size: 11pt;\n  line-height: 1.5;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n}\n\n/* ── Entête Carte Brune (logo + bureaux bilingues) ── */\n.att-header {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 18px;\n}\n.att-header-left,\n.att-header-right {\n  font-family: 'Inter', Arial, sans-serif;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #0b0f14;\n  letter-spacing: 0.3px;\n  line-height: 1.3;\n}\n/* Le francais est la langue de delivrance de l'attestation, l'anglais la\n   reprend pour les bureaux voisins : la hierarchie des tailles le dit, comme\n   elle le dit deja dans les libelles du tableau (9 pt contre 8 pt). La grille\n   de l'en-tete est en 1fr auto 1fr, donc deux tailles differentes laissent le\n   logo centre et les deux blocs alignes dos a dos. */\n.att-header-left {\n  font-size: 11pt;\n}\n.att-header-right {\n  font-size: 8.5pt;\n  text-align: right;\n}\n.att-logo {\n  width: 62px; height: 62px;\n  border-radius: 50%;\n  border: 2px solid #b45309;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Playfair Display', Georgia, serif;\n  font-weight: 700;\n  font-size: 7pt;\n  color: #b45309;\n  text-align: center;\n  line-height: 1.1;\n}\n.att-logo-img {\n  width: 72px;\n  height: 72px;\n  object-fit: contain;\n  display: block;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n\n/* ── Titre principal ── */\n.att-title-block {\n  text-align: center;\n  margin: 20px 0 18px;\n  border: 1.5px solid #0b0f14;\n  padding: 14px 24px;\n  display: inline-block;\n}\n.att-title-wrap {\n  text-align: center;\n  margin-bottom: 18px;\n}\n.att-title {\n  font-family: 'Inter', Arial, sans-serif;\n  font-size: 16pt;\n  font-weight: 800;\n  letter-spacing: 1.2px;\n  margin: 0;\n  text-transform: uppercase;\n}\n.att-subtitle {\n  font-size: 13pt;\n  font-weight: 700;\n  margin-top: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n}\n.att-sin-line {\n  margin-top: 8px;\n  font-size: 12pt;\n  font-weight: 600;\n}\n.att-sin-line .sin-label {\n  font-weight: 700;\n}\n.att-sin-line .sin-value {\n  display: inline-block;\n  min-width: 260px;\n  border-bottom: 1px solid #0b0f14;\n  padding: 0 10px;\n  text-align: center;\n  font-family: 'JetBrains Mono', Menlo, monospace;\n  font-size: 11pt;\n}\n\n/* ── Encadré IMPORTANT ── */\n.att-important {\n  border: 0.5px solid #5a6676;\n  padding: 8px 14px;\n  margin: 14px 0 18px;\n  font-size: 9.5pt;\n  line-height: 1.45;\n  color: #2a3340;\n}\n.att-important strong {\n  font-weight: 700;\n  color: #0b0f14;\n}\n.att-important .center {\n  text-align: center;\n  margin-top: 4px;\n}\n\n/* ── Paragraphe d'accroche ── */\n.att-accroche {\n  margin: 10px 0 16px;\n  font-size: 11pt;\n  line-height: 1.55;\n  text-align: justify;\n}\n\n/* ── Tableau d'informations (bordures fines) ── */\n.att-info-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 16px;\n  font-size: 10pt;\n}\n.att-info-table td {\n  border: 0.5px solid #0b0f14;\n  padding: 6px 10px;\n  vertical-align: middle;\n}\n.att-info-table .att-label {\n  width: 52%;\n  font-size: 9pt;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  color: #0b0f14;\n  font-weight: 600;\n}\n.att-info-table .att-label em {\n  font-style: italic;\n  color: #8a95a5;\n  font-weight: 400;\n  font-size: 8pt;\n  margin-left: 4px;\n  text-transform: none;\n  letter-spacing: 0;\n}\n.att-info-table .att-value {\n  font-size: 10.5pt;\n  font-weight: 600;\n  color: #0b0f14;\n}\n.att-info-table .att-value.mono {\n  font-family: 'JetBrains Mono', Menlo, monospace;\n  letter-spacing: 0.4px;\n}\n.att-info-table .att-value-with-code {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.att-info-table .att-initiales {\n  font-family: 'JetBrains Mono', Menlo, monospace;\n  font-weight: 700;\n  letter-spacing: 2px;\n  padding-left: 16px;\n  border-left: 1px solid #0b0f14;\n  margin-left: 12px;\n}\n\n/* ── Texte narratif (pour attestation de non garantie) ── */\n.att-narratif {\n  font-size: 11pt;\n  line-height: 1.7;\n  margin: 18px 0;\n  text-align: justify;\n}\n.att-narratif strong.underline {\n  font-weight: 700;\n  text-decoration: underline;\n  font-style: italic;\n}\n.att-narratif .pj-label {\n  font-weight: 700;\n  text-decoration: underline;\n  font-size: 11pt;\n}\n\n/* ── Fermeture (NB, signatures) ── */\n.att-closing {\n  margin-top: 14px;\n  font-size: 10pt;\n  line-height: 1.55;\n}\n.att-nb {\n  font-style: italic;\n  color: #2a3340;\n  font-size: 9.5pt;\n  line-height: 1.45;\n  margin: 12px 0;\n}\n.att-nb strong {\n  color: #0b0f14;\n  text-decoration: underline;\n  font-style: normal;\n}\n.att-fait-a {\n  margin-top: 14px;\n  text-align: right;\n  font-size: 11pt;\n}\n.att-pour-bncb {\n  text-align: right;\n  font-size: 11pt;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin-top: 2px;\n  letter-spacing: 0.4px;\n}\n.att-signature-espace {\n  min-height: 16mm;\n}\n\n/* ── Footer (adresse) ── */\n.att-footer {\n  position: absolute;\n  bottom: 10mm;\n  left: 18mm;\n  right: 18mm;\n  text-align: center;\n  font-size: 8.5pt;\n  color: #2a3340;\n  line-height: 1.4;\n  border-top: 0.5px solid #0b0f14;\n  padding-top: 4px;\n}\n\n/* ══════════ Print rules ══════════ */\n@page {\n  size: A4 portrait;\n  margin: 0;\n}\n\n@media print {\n  body, html {\n    background: white !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  .att-page {\n    background: white;\n    padding: 0;\n  }\n  .att-toolbar {\n    display: none !important;\n  }\n  .att-sheet {\n    box-shadow: none;\n    width: 210mm;\n    height: 297mm;\n    margin: 0;\n    padding: 16mm 18mm;\n    page-break-after: avoid;\n    page-break-inside: avoid;\n  }\n  .no-print {\n    display: none !important;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   CONFIRMATION DE GARANTIE (dossier TE, adressée au bureau homologue)\n   Reprend l'en-tête, le tableau et le pied de page de l'attestation ;\n   n'ajoute que la mise en page propre à une lettre.\n   ═══════════════════════════════════════════════════════════════ */\n.cg-destinataire {\n  margin-top: 14mm;\n  text-align: center;\n  font-size: 10.5pt;\n  letter-spacing: 0.5px;\n  line-height: 2;\n}\n\n.cg-lieu-date {\n  font-size: 10pt;\n}\n\n.cg-corps {\n  font-size: 11pt;\n  line-height: 1.75;\n  text-align: justify;\n  margin: 6mm 0;\n}\n\n/* Le tableau de références ne prend pas toute la largeur : c'est un encadré de\n   renvoi au milieu d'une lettre, pas le corps du document. */\n.cg-table {\n  width: 88%;\n  margin: 0 auto 6mm;\n}\n\n.cg-table .cg-label {\n  width: 34%;\n  font-weight: 600;\n}\n\n.cg-salutation {\n  font-size: 11pt;\n  margin-top: 4mm;\n  letter-spacing: 0.3px;\n}\n\n/* Champ absent du dossier : la ligne s'imprime en pointillés, à compléter à la\n   main, plutôt que de laisser un blanc qui passerait inaperçu. */\n.cg-a-completer {\n  letter-spacing: 2px;\n  color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
